import React, { useMemo } from 'react'
import { Button } from '../../../../../../../../components/Button/Button'
import { AiResult } from '../../../../../../../../models/AiResult'
import { CommentRelationType } from '../../../../../../../../models/MeetingSupport'
import { SidebarTitle, SidebarType } from '../../../../Sidebar/models'
import { AiFeature } from '../../../../../../../../models/AiFeature'
import { useAppDispatch, useAppSelector } from '../../../../../../../../store/hooks'
import { selectFilteredComments, setCommentedAiResultId } from '../../../../../../../../store/meetingSummary/meetingSupport'
import { displaySidebar, hideSidebar, selectDisplayedSidebar } from '../../../../../../../../store/meetingSummary/display'
import { MissingScopeAction } from '../../../../../../../../components/ScopedBlock/models'
import { ScopedBlock } from '../../../../../../../../components/ScopedBlock/ScopedBlock'
import { TrackEvent, useTracking } from '../../../../../common/tracking'
import { getAIFeatureAndResultTrackingDetails } from '../../../../../tracking'
import './HeaderResultCommentsButton.scss'
interface ResultCommentsButtonProps {
  aiFeature: AiFeature
  aiResult: AiResult
}

export const HeaderResultCommentsButton: React.FC<ResultCommentsButtonProps> = ({ aiFeature, aiResult }) => {
  const dispatch = useAppDispatch()

  const { tracked } = useTracking()

  const comments = useAppSelector(selectFilteredComments)
  const { displayedSidebar } = useAppSelector(selectDisplayedSidebar)

  const { id: aiResultId } = aiResult

  const commentCount = useMemo<number>(() => {
    return comments.filter(({ relationId, relationType }) => relationId === aiResultId && relationType === CommentRelationType.AI_RESULT).length
  }, [comments, aiResultId])

  const _handleOpenComments = () => {
    if (displayedSidebar === SidebarType.COMMENTS) {
      dispatch(hideSidebar())
    } else {
      const { name: aiFeatureName } = aiFeature
      const title = aiFeatureName ? `${SidebarTitle.COMMENTS} - ${aiFeatureName}` : SidebarTitle.COMMENTS
      dispatch(setCommentedAiResultId(aiResultId))
      dispatch(displaySidebar({ type: SidebarType.COMMENTS, title, icon: 'bi-chat-square-text' }))
    }
  }

  const handleOpenComments = tracked(
    _handleOpenComments,
    {
      eventName: TrackEvent.COMMENTS_OPENED,
      eventDetails: { ...getAIFeatureAndResultTrackingDetails(aiFeature, aiResult) },
    },
    { condition: displayedSidebar !== SidebarType.COMMENTS },
  )

  return (
    <ScopedBlock
      scope={{
        scope: 'comment:read',
        superScope: ['comment:admin'],
      }}
      missingScopeAction={MissingScopeAction.HIDE}
    >
      <Button className='px-2' variant='header' onClick={handleOpenComments}>
        <i className='bi bi-chat-square-text comment-icon' />
        <span className='badge text-bg-dark comment-count-badge'>{commentCount}</span>
      </Button>
    </ScopedBlock>
  )
}
